module.exports = __webpack_public_path__ + "img/back-primary.368108d9.svg";